import { MediaCategoryType, MediaImageType, MediaType } from "@nf/common";

export const filterOptions = {
  OnlyPublished: false,
  IncludeCategories: true,
  IncludeImages: true,
  IncludePeople: false,
  IncludeRecommendedMedia: false,
  IncludeCollections: true,
  IncludeSeoData: true,
  AssetType: MediaType.Series,
  MediaMapperOptions: {
    ExcludeYear: true,
    ExcludeDescription: true,
    ExcludeSeasons: true,
    ExcludeSubtitles: true,
    ExcludeProducts: false,
    ExcludeArticleFromCategories: true,
    ExcludeDescriptionFromCategories: true,
    ExcludeImagesFromCategories: true,
    ExcludeMediaAgeRestrictionValueMin: true,
    ExcludeCategoryType: [
      MediaCategoryType.Channel,
      MediaCategoryType.Label,
      MediaCategoryType.Other,
      MediaCategoryType.Format,
    ],
    ExcludeImageType: [
      MediaImageType.Any,
      MediaImageType.Cover,
      MediaImageType.Frame,
      MediaImageType.Highlights,
      MediaImageType.Background,
      MediaImageType.Promo,
      MediaImageType.Poster,
      MediaImageType.Square,
      MediaImageType.Hero_Frontpage,
      MediaImageType.Highlight_Asset_Details,
      MediaImageType.Highlight_Asset_Frontpage,
    ],
  },
};
